import { render, staticRenderFns } from "./metricasProdutos.vue?vue&type=template&id=2898353b"
import script from "./metricasProdutos.vue?vue&type=script&lang=js"
export * from "./metricasProdutos.vue?vue&type=script&lang=js"
import style0 from "./metricasProdutos.vue?vue&type=style&index=0&id=2898353b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports